var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.commissionDeductions.length
      ? _c(
          "div",
          { staticClass: "commissions-fees-header py-4 column-divider-bottom" },
          [
            _c(
              "b-row",
              _vm._l(_vm.columnHeaders, function (columnHeader, index) {
                return _c(
                  "div",
                  { key: "column-header-" + index, class: columnHeader.size },
                  [
                    _c(
                      "h6",
                      {
                        staticClass:
                          "theader theader-big m-0 cursor-auto text-left text-lg-center d-none d-lg-block",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(columnHeader.label) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "h6",
                      {
                        staticClass:
                          "theader theader-big m-0 cursor-auto text-left text-lg-center d-lg-none d-block",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              columnHeader.shortLabel || columnHeader.label
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "p-4" },
      [
        _vm._l(_vm.commissionDeductions, function (deduction) {
          return _c("commission-deduction", {
            key:
              deduction.deductionType + "-" + deduction.commissionsDeductionId,
            attrs: { deduction: deduction, "is-read-only": _vm.isReadOnly },
            on: {
              remove: function ($event) {
                return _vm.handleRemove(deduction.commissionsDeductionId)
              },
              save: function (value) {
                return _vm.handleSave(deduction.commissionsDeductionId, value)
              },
            },
          })
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass:
              "btn clickable text-primary bold bs-0 px-0 btn-transparent",
            attrs: { disabled: _vm.isReadOnly },
            on: { click: _vm.handleAdd },
          },
          [
            _vm._v(
              "\n      + " +
                _vm._s(
                  _vm.$t("direct-to-lender.commissions.deductions.addDeduction")
                ) +
                "\n    "
            ),
          ]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }